import S3Upload from 'react-s3-uploader/s3upload';

import Api from 'entities/api';

export const getGetSignedUrl =
  ({ acl, bucket, objectPrefix, ...s3CredentialsParams }) =>
  (file, callback) => {
    Api.post<{ signedRequest: string; publicUrl: string; url: string }>('api/files/credentials', {
      ...s3CredentialsParams,
      // eslint-disable-next-line camelcase
      file_name: S3Upload.prototype.scrubFilename(file.name),
      // eslint-disable-next-line camelcase
      file_type: file.type,
      acl,
      bucket,
      objectPrefix,
    }).subscribe(
      // eslint-disable-next-line n/no-callback-literal
      (response) => callback({ signedUrl: response.signedRequest, publicUrl: response.url }),
      (e) => console.error(e) // eslint-disable-line no-console
    );
  };
